var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component",attrs:{"event":_vm.event,"entity-by-id":_vm.entityById}})
}
var staticRenderFns = []

export { render, staticRenderFns }